import blockchainImg from "../../assets/images/articlesimg/blockchain-article.png";
import fairTransparentImg from "../../assets/images/articlesimg/Fair&Transparent_article.png";
import nftOwnershipImg from "../../assets/images/articlesimg/Nftownership-article.png";
import proofofparticipation from "../../assets/images/articlesimg/proofofparticipation-article.png";
import automaticwinnerselection from "../../assets/images/articlesimg/AutomaticWinnerSelection-article.png";
import tieredprizes from "../../assets/images/articlesimg/TireredPrizes-article.png";
import referralprogram from "../../assets/images/articlesimg/ReferralProgramArticle.jpg";
import biggerpayouts from "../../assets/images/articlesimg/BiggerPayoutArticle.png";
import realtimeupdate from "../../assets/images/articlesimg/RealTimeUpdateArticle.png";
import automaticPrizeDeliveryImg from "../../assets/images/articlesimg/AutomaticPrizeDelivery-article.png";
import publicBlockchainTrackingImg from "../../assets/images/articlesimg/BlockchainTrackingArticle.png";
import mobileWebAccessImg from "../../assets/images/articlesimg/Mobile&WebAccesArticle.png";
import TrustlessSystemArticleImage from "../../assets/images/articlesimg/TrustlessSystem-article.png";
import CreatorFriendlyArticleImage from "../../assets/images/articlesimg/creatorfriendly-article.jpeg";
import ZeroPaperWorkArticleImage from "../../assets/images/articlesimg/ZeroPaperWork-article.png";

const articles = [
  {
    id: "blockchain-lottery",
    title:
      "Blockchain Lottery: The Future of Transparent and Decentralized Gaming",
    image: blockchainImg,
    description:
      "Lottery systems have existed for centuries, providing people with an opportunity to win life-changing prizes. However, traditional lotteries have been plagued by issues such as lack of transparency, centralized control, and unfair winner selection.",
    keywords:
      "blockchain lottery, decentralized gaming, transparent lottery, crypto lottery, web3 lottery",
    date: "2023-01-15",
  },
  {
    id: "fair-transparent",
    title: "100% Fair and Transparent Lottery",
    image: fairTransparentImg,
    description:
      "Every ticket, winner, and prize is recorded on the blockchain — no hidden decisions, no rigging possible.",
    keywords:
      "fair lottery, transparent lottery, blockchain lottery, verifiable lottery, no rigging",
    date: "2023-02-20",
  },
  {
    id: "nft-ownership",
    title:
      "Ticket Equals NFT Ownership: A New Era in Digital Lottery Participation",
    image: nftOwnershipImg,
    description:
      "When you buy a ticket, you get a digital collectible (NFT) that proves your entry — it's yours forever!",
    keywords:
      "NFT lottery, digital collectible, ticket ownership, blockchain ticket, crypto lottery",
    date: "2023-03-10",
  },
  {
    id: "instant-proof-of-participation",
    title:
      "Ticket Equals Instant Proof of Participation: Verifying Lottery Entries on the Blockchain",
    image: proofofparticipation,
    description:
      "See your tickets and history instantly. No need to trust a centralized system — it's all on-chain.",
    keywords:
      "proof of participation, blockchain verification, lottery entry, on-chain lottery, instant proof",
    date: "2023-04-05",
  },
  {
    id: "automatic-winner-selection",
    title:
      "Automatic Winner Selection: Ensuring True Fairness with Blockchain Randomness",
    image: automaticwinnerselection,
    description:
      "Winners are picked automatically using blockchain randomness — even we can’t interfere!",
    keywords:
      "automatic winner selection, blockchain randomness, fair winner, unbiased lottery, smart contract lottery",
    date: "2023-05-12",
  },
  {
    id: "tiered-prizes-more-wins",
    title:
      "Ticket Tiered Prizes: Increasing Your Chances to Win with Blockchain Lotteries",
    image: tieredprizes,
    description:
      " Not just 1 lucky winner — we support multiple levels of prizes, so more people get rewarded.",
    keywords:
      "tiered prizes, multiple winners, blockchain lottery, increased chances, lottery rewards",
    date: "2023-06-01",
  },
  {
    id: "referral-program-benefits",
    title:
      "Earn Even If You Don’t Win: Unlocking Earnings Through SWSS Draw’s Referral Program",
    image: referralprogram,
    description:
      "Share your referral link and earn a percentage every time your friend buys a ticket.",
    keywords:
      "referral program, earn crypto, lottery earnings, SWSSDraw referral, blockchain rewards",
    date: "2023-07-08",
  },
  {
    id: "low-fees-bigger-payouts",
    title:
      "Low Fees, Bigger Payouts: How SWSS Draw Maximizes Your Lottery Experience",
    image: biggerpayouts,
    description:
      "Most of your ticket money goes directly into the prize pool — not into admin pockets.",
    keywords:
      "low fees lottery, bigger payouts, SWSSDraw, transparent fees, maximized winnings",
    date: "2023-08-19",
  },
  {
    id: "real-time-updates",
    title: "Real-Time Updates: Enhancing Transparency in Blockchain Lotteries",
    image: realtimeupdate,
    description:
      "Follow the status of any draw — from creation to prize distribution — all in real-time.",
    keywords:
      "real-time updates, blockchain lottery, transparent draw, live status, crypto lottery",
    date: "2023-09-25",
  },
  {
    id: "automatic-prize-delivery",
    title:
      "Fast, Automatic Prize Delivery: Revolutionizing the Lottery Experience",
    image: automaticPrizeDeliveryImg,
    description:
      "Once winners are selected, prizes are sent out automatically — no waiting, no chasing",
    keywords:
      "automatic prize delivery, fast payout, blockchain lottery, instant winnings, smart contract payout",
    date: "2023-10-30",
  },
  {
    id: "public-blockchain-tracking",
    title:
      "Track Everything Publicly: The Transparency Revolution in Lotteries",
    image: publicBlockchainTrackingImg,
    description:
      "Anyone can verify the winners, ticket numbers, and payouts on the blockchain.",
    keywords:
      "public blockchain tracking, lottery transparency, verifiable results, on-chain data, crypto lottery",
    date: "2023-11-03",
  },
  {
    id: "mobile-web-access",
    title: "Built for Mobile and Web: Seamless Access to Blockchain Lotteries",
    image: mobileWebAccessImg,
    description:
      "Access SWSS Draw from anywhere — your phone, laptop, or tablet — it's easy to use.",
    keywords:
      "mobile lottery, web access, cross-platform, accessible lottery, SWSSDraw",
    date: "2023-12-11",
  },
  {
    id: "trustless-system",
    title:
      "Trustless System: Ensuring Fairness and Security Through Blockchain",
    image: TrustlessSystemArticleImage,
    description:
      "You don’t need to trust us — the code handles everything. It’s built so no one can cheat.  ",
    keywords:
      "trustless system, blockchain security, fair lottery, no cheating, decentralized trust",
    date: "2024-01-01",
  },
  {
    id: "creator-friendly",
    title:
      "Creator-Friendly: Empowering Fair Draw Organizers with Blockchain Technology",
    image: CreatorFriendlyArticleImage,
    description:
      "Want to run your own draw? SWSS Draw gives event creators the tools to launch their own fair, secure draws.",
    keywords:
      "creator-friendly, draw organizer, blockchain events, fair draws, secure events",
    date: "2024-02-14",
  },
  {
    id: "zero-paperwork",
    title:
      "Zero Paperwork or Registrations: The Future of Effortless Participation",
    image: ZeroPaperWorkArticleImage,
    description:
      "No forms, no emails — just connect your crypto wallet and you're ready to go!",
    keywords:
      "zero paperwork, no registration, effortless participation, crypto wallet, fast access",
    date: "2024-03-28",
  },
];

export default articles;
